import { Col, Radio, Row } from "antd";
import React from "react";
import { translate } from "react-i18next";
import { compose } from "redux";
import {
  GUTTER_MD,
  MARGIN_MD
} from "../../../../../../styles/constants";
import { getMappingType, mappingTypeCalculated, mappingTypeConcat, mappingTypeFixed } from "../../utils";
import ConcatenatedComponent from "./concatenated/ConcatenatedComponent";
import FixedComponent from "./FixedComponent";
import CalculatedComponent from "./calculated/CalculatedComponent";

const FileMappingWizardComponentValueDefinitionForm = ({
  t,
  appLanguage,
  componentValueDefinition,
  cubeComponents,
  onComponentValueDefinitionTypeSet,
  onComponentValueDefinitionValueSet,
  componentCodelistCodesItemsPage,
  componentCodelistCodesItemsCount,
  fetchCodelistCodesItemsPage
}) => {

  const currentMappingType = getMappingType(componentValueDefinition);

  const codelistCode = componentValueDefinition && componentValueDefinition.cubeComponent 
    ? componentValueDefinition.cubeComponent.CodelistCode || ""
    : null;

  return (
    <div >
      <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
        <Col>
          <Radio.Group
            defaultValue={mappingTypeFixed}
            value={currentMappingType}
            onChange={({ target }) =>
            onComponentValueDefinitionTypeSet(target.value, cubeComponents)
            }
          >
            <Radio.Button value={mappingTypeFixed}>
              {t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.selectorType.fixed')}
            </Radio.Button>
            <Radio.Button value={mappingTypeCalculated}>
              {t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.selectorType.calculated')}
            </Radio.Button>
            <Radio.Button value={mappingTypeConcat}>
              {t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.selectorType.concatenated')}
            </Radio.Button>
          </Radio.Group>
        </Col>
      </Row>
      <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
        <Col>
          {currentMappingType === mappingTypeFixed  && ( 
            <FixedComponent
              appLanguage={appLanguage}
              codelistCode={codelistCode}
              componentValueDefinition={componentValueDefinition}
              componentCodelistCodesItemsPage={componentCodelistCodesItemsPage}
              componentCodelistCodesItemsCount={componentCodelistCodesItemsCount}
              fetchCodelistCodesItemsPage={fetchCodelistCodesItemsPage}
              onComponentValueDefinitionValueSet={onComponentValueDefinitionValueSet}  
            />
          )}
          {currentMappingType === mappingTypeCalculated  && (
            <CalculatedComponent
              appLanguage={appLanguage}
              cubeComponents={cubeComponents}
              codelistCode={codelistCode}
              componentValueDefinition={componentValueDefinition}
              onComponentValueDefinitionValueSet={onComponentValueDefinitionValueSet}
              componentCodelistCodesItemsPage={componentCodelistCodesItemsPage}
              componentCodelistCodesItemsCount={componentCodelistCodesItemsCount}
              fetchCodelistCodesItemsPage={fetchCodelistCodesItemsPage}
            />
          )}
          {currentMappingType === mappingTypeConcat  && (
            <ConcatenatedComponent
              componentValueDefinition={componentValueDefinition}
              cubeComponents={cubeComponents}
              onComponentValueDefinitionValueSet={onComponentValueDefinitionValueSet}
            />
          )} 
        </Col>
      </Row>     
    </div>                                
  );
};

export default compose(translate())(
  FileMappingWizardComponentValueDefinitionForm
);
